/*
 * Copyright (c) 2024 Cozy Intellect Inc.
 */

/**
 * Encodes an array of providerId-calendarId pairs into a query string format.
 * @param pairs Array of pairs in the format [providerId, calendarId].
 * @returns Encoded query string value.
 */
export function encodePairs(pairs: string[][]): string {
  return pairs.map(([providerId, calendarId]) => `${providerId}|${calendarId}`).join(',');
}

/**
 * Decodes a query string into an array of providerId-calendarId pairs.
 * @param encodedPairs Encoded query string value.
 * @returns Array of pairs in the format [providerId, calendarId].
 */
export function decodePairs(encodedPairs: string): Record<string, string[]> {
  const decoded: Record<string, string[]> = {};
  encodedPairs.split(',').map((pair) => {
    const [providerId, calendarId] = pair.split('|');
    if (!decoded[providerId]) {
      decoded[providerId] = [];
    }
    decoded[providerId].push(calendarId);
  });
  return decoded;
}
